import { createContext } from 'react'

import { createBizAuctionDetailStore } from '../../../Biz/Store/store/createStore'

export const AuctionDetailStoreContext = createContext<
  ReturnType<typeof createBizAuctionDetailStore> | undefined
>(undefined)
